import { Account } from "@common/types/domains/accounting/account";
import { MatchableItem } from "../types";

interface RemainingLedgerOptions {
    accounts?: Account[];
    entityId?: number;
    accountsByEntityId?: Record<number, Account[]>;
}

/**
 * The single-transaction drawer sets one `entityId` and `accounts` for the
 * whole table. The multi-transaction drawer can mix entities, so it leaves
 * those unset and each row resolves its own chart from `ledgerEntityId`.
 */
export function resolveRemainingRowLedger({
    options,
    item,
}: {
    options: RemainingLedgerOptions | undefined;
    item: Pick<MatchableItem, "entityId" | "ledgerEntityId">;
}): { entityId: number; accounts: Account[] | undefined } {
    const entityId = options?.entityId ?? item.ledgerEntityId ?? item.entityId;
    return {
        entityId,
        accounts: options?.accounts ?? options?.accountsByEntityId?.[entityId],
    };
}
